<template>
  <div class="StartViewHint">
    <div class="content">
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            1
          </div>
        </div>
        <label>
          Dodaj adres swojej strony internetowej w zakładce "Widgety",
          na której ma być widoczny widget
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            2
          </div>
        </div>
        <label>
          Skopiuj kod html wybranego widgetu i wklej go na swoją stronę internetową
          do sekcji &lt;head&gt;
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            3
          </div>
        </div>
        <label>
          Dodaj i zweryfikuj numer telefonu
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            4
          </div>
        </div>
        <label>
          Dodaj konsultanta
        </label>
      </div>
      <div class="content__footer">
        Konfiguracja widgetu call web to tylko kilka minut! Podążaj zgodnie z instrukcjami.
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'StartViewHint',


};
</script>
